import { useState, useEffect } from 'react';

import { sendEvent } from '../../../../../core/services/tracking';

import AD_QUANTITY from './constants';

export default function useDropdown(onSelect, openContactModal, posData) {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState(AD_QUANTITY[0].text);

  function close() {
    setIsOpen(false);
  }

  function onClick(value) {
    setIsOpen(value);
  }

  function onClickItem(text, value) {
    sendEvent({
      event_type: 'click',
      object_detail: 'dropdown',
      data: {
        funnel_id: posData.funnelId,
        point_of_sale: 'cars-subscription-bundle',
        referral: posData.referral,
        selectedOption: value,
      },
    });

    if (value > 50) {
      openContactModal();
    } else {
      setTitle(text);
      onSelect(value);
    }

    close();
  }

  useEffect(() => {
    setTimeout(() => {
      if (isOpen) {
        window.addEventListener('click', close);
      } else {
        window.removeEventListener('click', close);
      }
    }, 0);

    return () => {
      window.removeEventListener('click', close);
    };
  });

  return {
    title,
    isOpen,
    onClick,
    onClickItem,
  };
}
